var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path10, _g10, _path11, _g11, _path12, _g12, _path13, _g13, _path14, _g14, _path15, _g15, _path16, _g16, _path17, _g17, _path18, _g18, _path19, _g19, _path20, _g20, _path21, _g21, _path22, _g22, _path23, _g23, _path24, _g24, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOurSolutionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 80,
    viewBox: "0 0 70 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_131)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_22_131",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 66,
    height: 77
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 2H2V79H68V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_22_131)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1139 20.6921C23.2606 14.217 28.5819 9.10354 35.1265 9.20004C35.7858 9.20976 36.3124 9.75483 36.3027 10.4175C36.293 11.0802 35.7507 11.6095 35.0914 11.5997C29.8347 11.5222 25.6172 15.6124 25.501 20.747L25.501 20.7474C25.4416 23.3367 26.4808 25.236 28.0797 27.3981C28.4051 27.8369 28.7103 28.1801 29.0118 28.5078C29.0587 28.5587 29.1066 28.6105 29.1553 28.663C29.4084 28.9362 29.6821 29.2317 29.9311 29.5481C30.5817 30.3746 31.0651 31.3361 31.3931 32.961C31.5242 33.6105 31.1066 34.2439 30.4604 34.3756C29.8142 34.5074 29.1841 34.0877 29.053 33.4382C28.79 32.1351 28.4482 31.5321 28.0586 31.0372C27.8743 30.803 27.6773 30.59 27.4256 30.3179C27.3726 30.2606 27.3172 30.2007 27.2589 30.1374C26.9355 29.7859 26.5645 29.3708 26.1648 28.8318L26.1638 28.8305C24.4619 26.5291 23.0361 24.0907 23.1139 20.6925",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_22_131",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 66,
    height: 77
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68 2H2V79H68V2Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_22_131)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.7169 20.7474C44.5979 15.6119 40.3825 11.5223 35.1264 11.5997C34.4671 11.6095 33.9248 11.0802 33.9152 10.4175C33.9055 9.75483 34.4321 9.20976 35.0914 9.20004C41.6366 9.10353 46.9542 14.2176 47.104 20.6919L47.104 20.6921C47.1819 24.0905 45.756 26.529 44.0541 28.8305L44.0531 28.8318C43.6445 29.3827 43.251 29.8058 42.8996 30.1645C42.7936 30.2727 42.6967 30.3701 42.6062 30.4609C42.3815 30.6866 42.197 30.8719 42.0148 31.0816C41.5798 31.5822 41.205 32.1731 40.9499 33.4354C40.8187 34.0849 40.1885 34.5045 39.5423 34.3726C38.8962 34.2407 38.4787 33.6073 38.6099 32.9578C38.9458 31.2952 39.5037 30.323 40.2164 29.5029C40.4563 29.2267 40.7243 28.9577 40.9686 28.7124C41.0483 28.6324 41.1254 28.555 41.1982 28.4806C41.5121 28.1602 41.8217 27.8249 42.1383 27.398C43.737 25.236 44.7762 23.3368 44.7169 20.7477",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_22_131",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 66,
    height: 77
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68 2H2V79H68V2Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_22_131)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.777 31.9996C40.4363 31.9996 40.9709 32.5369 40.9709 33.1996C40.9709 33.8623 40.4363 34.3996 39.777 34.3996L30.3816 34.4026C29.7223 34.4028 29.1876 33.8657 29.1874 33.203C29.1872 32.5402 29.7215 32.0028 30.3809 32.0026L39.777 31.9996Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_22_131",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 66,
    height: 77
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68 2H2V79H68V2Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_22_131)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7769 31.9996C40.4363 31.9996 40.9708 32.5369 40.9708 33.1996V36.7995C40.9708 37.0183 40.9113 37.2329 40.7988 37.4201L38.6349 41.02C38.4187 41.3797 38.0311 41.5995 37.613 41.5995H35.1089C34.4496 41.5995 33.915 41.0622 33.915 40.3995C33.915 39.7368 34.4496 39.1995 35.1089 39.1995H36.9395L38.5831 36.4652V33.1996C38.5831 32.5369 39.1176 31.9996 39.7769 31.9996Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_22_131",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 66,
    height: 77
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68 2H2V79H68V2Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_22_131)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3963 15.4791C37.7226 14.9031 38.4516 14.7021 39.0245 15.03C40.757 16.0215 42.0457 17.6761 42.4293 19.6632C42.5549 20.3138 42.132 20.9435 41.4847 21.0698C40.8374 21.196 40.2109 20.7709 40.0853 20.1203C39.8481 18.8914 39.0356 17.7981 37.8431 17.1156C37.2701 16.7877 37.0701 16.055 37.3963 15.4791Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_22_131",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 66,
    height: 77
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68 2H2V79H68V2Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_22_131)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.226 31.9996C30.8853 31.9996 31.4198 32.5369 31.4198 33.1996V36.4377L33.2425 39.1995H35.0014C35.6608 39.1995 36.1953 39.7368 36.1953 40.3995C36.1953 41.0622 35.6608 41.5995 35.0014 41.5995H32.6018C32.2016 41.5995 31.8281 41.398 31.6069 41.0628L29.2311 37.4629C29.1013 37.2662 29.0321 37.0355 29.0321 36.7995V33.1996C29.0321 32.5369 29.5666 31.9996 30.226 31.9996Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_22_131",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 66,
    height: 77
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68 2H2V79H68V2Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_22_131)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9835 53.8003C35.6429 53.8003 36.1774 54.3376 36.1774 55.0003V77.8C36.1774 78.4627 35.6429 79 34.9835 79C34.3242 79 33.7897 78.4627 33.7897 77.8V55.0003C33.7897 54.3376 34.3242 53.8003 34.9835 53.8003Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_22_131",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 66,
    height: 77
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68 2H2V79H68V2Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_22_131)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0292 43.4627C12.3241 42.87 13.0412 42.6298 13.6309 42.9262L35.5175 53.927C36.1072 54.2235 36.3462 54.9443 36.0513 55.537C35.7564 56.1298 35.0393 56.37 34.4496 56.0736L12.563 45.0727C11.9733 44.7763 11.7343 44.0555 12.0292 43.4627Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_22_131",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 66,
    height: 77
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68 2H2V79H68V2Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_22_131)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7881 43.0209C14.3257 43.4045 14.4522 44.1536 14.0705 44.694L7.10781 54.5531L26.8333 64.465L34.0101 54.3056C34.3919 53.7652 35.1371 53.6382 35.6748 54.0219C36.2124 54.4056 36.3388 55.1547 35.957 55.695L28.1879 66.6929C27.8471 67.1754 27.2072 67.3361 26.6806 67.0715L4.79405 56.0736C4.48229 55.917 4.25421 55.6312 4.16968 55.2913C4.08515 54.9514 4.15262 54.5914 4.35438 54.3057L12.1235 43.3049C12.5051 42.7644 13.2504 42.6373 13.7881 43.0209Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_22_131",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 66,
    height: 77
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68 2H2V79H68V2Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_22_131)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1918 43.0119C56.7345 42.6354 57.478 42.7723 57.8526 43.3177L65.4516 54.3816C65.648 54.6676 65.7114 55.0252 65.6254 55.3619C65.5394 55.6985 65.3123 55.9811 65.003 56.1366L43.1165 67.1374C42.5845 67.4048 41.9379 67.2379 41.6 66.7459L34.001 55.682C33.6264 55.1366 33.7627 54.3893 34.3053 54.0128C34.8479 53.6363 35.5914 53.7732 35.966 54.3186L42.9759 64.5248L62.7056 54.608L55.8876 44.6812C55.513 44.1358 55.6492 43.3884 56.1918 43.0119Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_22_131",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 66,
    height: 77
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M68 2H2V79H68V2Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_22_131)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.9379 43.4627C58.2328 44.0555 57.9938 44.7763 57.4041 45.0727L35.5175 56.0736C34.9278 56.37 34.2107 56.1298 33.9158 55.537C33.6209 54.9443 33.8599 54.2235 34.4496 53.927L56.3362 42.9262C56.9259 42.6298 57.643 42.87 57.9379 43.4627Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_22_131",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 66,
    height: 77
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M68 2H2V79H68V2Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_22_131)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0969 58.3993C13.7563 58.3993 14.2908 58.9365 14.2908 59.5992V66.0576L35.5175 76.7267C36.1072 77.0232 36.3462 77.744 36.0513 78.3367C35.7564 78.9295 35.0393 79.1697 34.4496 78.8733L12.563 67.8724C12.1585 67.6691 11.9031 67.2537 11.9031 66.7992V59.5992C11.9031 58.9365 12.4376 58.3993 13.0969 58.3993Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_22_131",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 66,
    height: 77
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M68 2H2V79H68V2Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_22_131)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.8701 58.3993C57.5295 58.3993 58.064 58.9365 58.064 59.5992V66.7992C58.064 67.2537 57.8085 67.6691 57.4041 67.8724L35.5175 78.8733C34.9278 79.1697 34.2107 78.9295 33.9158 78.3367C33.6209 77.744 33.8599 77.0232 34.4496 76.7267L55.6763 66.0576V59.5992C55.6763 58.9365 56.2108 58.3993 56.8701 58.3993Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_22_131",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 66,
    height: 77
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M68 2H2V79H68V2Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_22_131)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0015 2C35.6608 2 36.1954 2.53725 36.1954 3.19998V5.59995C36.1954 6.26269 35.6608 6.79994 35.0015 6.79994C34.3421 6.79994 33.8076 6.26269 33.8076 5.59995V3.19998C33.8076 2.53725 34.3421 2 35.0015 2Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_22_131",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 66,
    height: 77
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M68 2H2V79H68V2Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_22_131)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4934 7.6224C21.9596 7.15378 22.7155 7.15378 23.1817 7.6224L24.8711 9.32038C25.3373 9.789 25.3373 10.5488 24.8711 11.0174C24.4048 11.486 23.6489 11.486 23.1827 11.0174L21.4934 9.31944C21.0271 8.85081 21.0271 8.09103 21.4934 7.6224Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_22_131",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 66,
    height: 77
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M68 2H2V79H68V2Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_22_131)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8997 21.1997C15.8997 20.537 16.4342 19.9998 17.0935 19.9998H19.4813C20.1406 19.9998 20.6751 20.537 20.6751 21.1997C20.6751 21.8625 20.1406 22.3997 19.4813 22.3997H17.0935C16.4342 22.3997 15.8997 21.8625 15.8997 21.1997Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_22_131",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 66,
    height: 77
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M68 2H2V79H68V2Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_22_131)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8711 31.3821C25.3373 31.8507 25.3373 32.6105 24.8711 33.0791L23.1817 34.7771C22.7155 35.2457 21.9596 35.2457 21.4934 34.7771C21.0271 34.3085 21.0271 33.5487 21.4934 33.0801L23.1827 31.3821C23.6489 30.9135 24.4048 30.9135 24.8711 31.3821Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_22_131",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 66,
    height: 77
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M68 2H2V79H68V2Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_22_131)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.1326 31.3813C45.5993 30.9131 46.3552 30.9138 46.821 31.3828L48.5074 33.0808C48.9732 33.5499 48.9725 34.3096 48.5059 34.7779C48.0392 35.2461 47.2833 35.2454 46.8175 34.7764L45.1312 33.0784C44.6653 32.6093 44.666 31.8496 45.1326 31.3813Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_22_131",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 66,
    height: 77
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M68 2H2V79H68V2Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_22_131)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3279 21.1997C49.3279 20.537 49.8624 19.9998 50.5217 19.9998H52.9095C53.5688 19.9998 54.1034 20.537 54.1034 21.1997C54.1034 21.8625 53.5688 22.3997 52.9095 22.3997H50.5217C49.8624 22.3997 49.3279 21.8625 49.3279 21.1997Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_22_131",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 66,
    height: 77
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M68 2H2V79H68V2Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_22_131)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.5059 7.62165C48.9725 8.08986 48.9732 8.84965 48.5074 9.31869L46.821 11.0167C46.3552 11.4857 45.5993 11.4864 45.1326 11.0182C44.666 10.55 44.6653 9.79017 45.1312 9.32113L46.8175 7.62315C47.2833 7.15412 48.0392 7.15344 48.5059 7.62165Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_22_131",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 66,
    height: 77
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M68 2H2V79H68V2Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_22_131)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5004 37.2618C26.7953 37.8545 26.5563 38.5753 25.9666 38.8718L13.631 45.0727C13.0413 45.3691 12.3241 45.1289 12.0292 44.5362C11.7343 43.9435 11.9732 43.2226 12.5629 42.9262L24.8986 36.7253C25.4883 36.4288 26.2054 36.669 26.5004 37.2618Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_22_131",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 66,
    height: 77
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M68 2H2V79H68V2Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_22_131)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7733 28.7722C19.068 29.365 18.8289 30.0857 18.2391 30.382L5.46392 36.7997L13.8094 43.0365C14.3385 43.4319 14.4485 44.1836 14.0551 44.7154C13.6617 45.2473 12.9138 45.3579 12.3847 44.9624L2.48154 37.5615C2.14876 37.3128 1.96821 36.9084 2.00462 36.4932C2.04104 36.078 2.2892 35.7115 2.66014 35.5252L17.1716 28.2353C17.7614 27.939 18.4785 28.1794 18.7733 28.7722Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_22_131",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 66,
    height: 77
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M68 2H2V79H68V2Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_22_131)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.2298 28.7721C51.5246 28.1793 52.2417 27.939 52.8315 28.2353L67.3399 35.5252C67.7108 35.7116 67.959 36.078 67.9954 36.4931C68.0318 36.9083 67.8513 37.3127 67.5186 37.5614L57.6185 44.9623C57.0894 45.3578 56.3415 45.2474 55.948 44.7156C55.5545 44.1838 55.6644 43.4321 56.1935 43.0366L64.5365 36.7997L51.7638 30.382C51.174 30.0857 50.9349 29.3649 51.2298 28.7721Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_22_131",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 66,
    height: 77
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M68 2H2V79H68V2Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_22_131)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4846 37.2708C43.7796 36.678 44.4967 36.4378 45.0864 36.7343L57.4041 42.9262C57.9939 43.2226 58.2328 43.9435 57.9379 44.5362C57.643 45.1289 56.9258 45.3691 56.3361 45.0727L44.0184 38.8808C43.4287 38.5843 43.1897 37.8635 43.4846 37.2708Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 77,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurSolutionIcon);
export default __webpack_public_path__ + "static/media/our-solution-icon.fb809f85c06ff9798b3b17058908c1a8.svg";
export { ForwardRef as ReactComponent };